import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="ttyTWZGLLps"
                    title="Telekom Speedport Portforwarding"
                    adNetwork={true}
                    poster="hqdefault" //maxresdefault
                    noCookie={true}
                />
              }
              title="Telekom Speedport Portforwarding"
              footer={
                <EuiText>
                  <p>Einrichtung der Portweiterleitung im Speedport.  </p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
